<template>
  <div>
    <el-tag size="mini" v-if="statusCode === 1" type="info">已提交</el-tag>
    <el-tag size="mini" v-else-if="statusCode === 2" type="success" effect="dark">已支付</el-tag>
    <el-tag size="mini" v-else-if="statusCode === 3">服务中</el-tag>
    <el-tag size="mini" v-else-if="statusCode === 4" effect="plain">待评价</el-tag>
    <el-tag size="mini" v-else-if="statusCode === 5" type="success">完成</el-tag>
    <el-tag size="mini" v-else type="info" effect="dark">未知</el-tag>
  </div>
</template>

<script>
export default {
  name: 'SaleOrderStatus',
  props: {
    statusCode: {
      type: Number
    }
  },
};
</script>

<style scoped>
</style>
